import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useLang } from "@/context/LangContext";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Services() {
  const { t } = useLang();
  const [services, setServices] = useState([]);

  useEffect(() => {
    axios.get(`${API}/content/services`).then(r => setServices(r.data)).catch(() => {});
  }, []);

  if (!services.length) return null;

  return (
    <section id="experiences" className="relative py-16 md:py-32 bg-[#050505]" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12">
        <div className="mb-10 md:mb-16 text-center">
          <span className="text-[#E60000] text-xs sm:text-sm uppercase tracking-[0.3em] font-medium font-body">{t.services.section_tag}</span>
          <h2 className="font-heading text-2xl sm:text-3xl md:text-4xl lg:text-5xl tracking-tight font-bold uppercase text-white mt-3" data-testid="services-title">
            {t.services.title} <span className="text-[#E60000]">{t.services.title_accent}</span>
          </h2>
          <p className="font-body text-sm sm:text-base text-[#A3A3A3] mt-3 max-w-2xl mx-auto">{t.services.subtitle}</p>
        </div>

        <div className={`grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 gap-2 sm:gap-3 ${services.length === 5 ? "lg:grid-cols-5" : services.length === 4 ? "lg:grid-cols-4" : "lg:grid-cols-3"}`}>
          {services.map((s, i) => (
            <motion.div
              key={s.id || i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-30px" }}
              transition={{ delay: i * 0.08, duration: 0.5 }}
              className="group relative overflow-hidden border border-red-900/20 hover:border-[#E60000]/60 transition-all duration-500 cursor-pointer aspect-square"
              data-testid={`service-card-${i}`}
            >
              <img
                src={s.image}
                alt={s.title}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
              <div className="absolute inset-0 bg-[#E60000]/0 group-hover:bg-[#E60000]/10 transition-colors duration-500" />

              <div className="relative z-10 h-full flex flex-col justify-end p-3 sm:p-4 md:p-5">
                <h3 className="font-heading text-xs sm:text-sm md:text-base font-bold uppercase text-white mb-1 tracking-tight leading-tight">
                  {s.title}
                </h3>
                <p className="font-body text-[10px] sm:text-xs text-white/60 leading-snug mb-2 hidden sm:block">
                  {s.description}
                </p>
                {s.tags?.length > 0 && (
                  <div className="flex flex-wrap gap-1">
                    {s.tags.map((tag) => (
                      <span key={tag} className="text-[8px] sm:text-[9px] uppercase tracking-wider text-[#E60000]/80 border border-[#E60000]/30 px-1.5 py-0.5 bg-black/50">
                        {tag}
                      </span>
                    ))}
                  </div>
                )}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
